import ReactDOM from 'react-dom/client';
import App from './App';
import AppProviders from './providers/AppProviders';
import { setupMediaProtection } from './utils/setupMediaProtection';
import './index.css';

setupMediaProtection();

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
	<AppProviders>
		<App />
	</AppProviders>,
);
